module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/instagram-8e5c2b7df67db33b40b67b52f691db19.svg";